import { KirbyQuerySchema } from "./kql"

export * from "./about"

export interface KirbyPageData {
  isListed: boolean
  template: string
  title: string
  uri: string
  id: string
  uuid: string
}

export const baseQuery: KirbyQuerySchema["select"] = {
  isListed: true,
  template: "page.intendedTemplate",
  title: true,
  uri: true,
  id: true,
  uuid: true,
}
